import React from 'react';

import {
  Box,
  Grid,
  styled,
  Typography
} from '@mui/material';
import {
  activityTemplates,
  AuthWrapper,
  BackButton,
  baseTypes,
  DownloadableResourceBox,
  imageUtil,
  LoadingOverlay,
  routeDirectory
} from 'modules';
import {
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';

import * as dataService from './dataService';



const BackButtonBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(8)
}));



export const PitchDeckTemplateActivity: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const params = useParams<{
    group: string;
    title: string;
  }>();

  const { loading, data, pageInfo } = dataService.usePitchDeckThumbnailActivity(params.group, params.title);

  const view = params.title ? 'titleView' : 'groupView';
  const __backButtonLabel = baseTypes.isNavigationState(state) && state.prevPath === routeDirectory.pitchDecks.rawPath
    ? 'Back to Pitch Decks'
    : pageInfo.backButtonText;



  return (
    <AuthWrapper.FC>
      <activityTemplates.BaseActivityTemplate.FC>
        <LoadingOverlay active={loading} />

        <BackButtonBox>
          <BackButton.FC label={__backButtonLabel}/>
        </BackButtonBox>

        <Box marginBottom={4}>
          <Typography variant="h2">{pageInfo.heading}</Typography>
        </Box>

        <Grid
          container
          spacing={3}
          rowSpacing={5}>
          {data.map((d, index) => (
            <Grid
              key={d.id}
              item>
              <DownloadableResourceBox.FC
                apiFileUrl={imageUtil.getFileUrl(d.thumbnailKey)}
                title={
                  view === 'titleView'
                    ? `${d.title} Slide ${index + 1}`
                    : d.title
                }
                apiFileData={
                  view === 'titleView' && d.slide
                    ? {
                      id: d.slide.id,
                      key: d.slide.key,
                      fileName: d.slide.fileName,
                      title: d.title
                    }
                    : undefined
                }
                maxWidth={420}
                onClickImage={
                  view === 'titleView'
                    ? undefined
                    : () => navigate(routeDirectory.pitchDecks.title.path(d.slideGroup.name, d.title))
                }
                layoutVariant={view === 'groupView' ? 'slide' : undefined}
                showSnackbarHint
              />
            </Grid>
          ))}
        </Grid>
      </activityTemplates.BaseActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
